"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*eslint-disable react/no-danger*/
const react_1 = __importDefault(require("react"));
const prop_types_1 = require("prop-types");
const styles_1 = require("./styles");
const Banners_1 = require("../../Banners");
const Markdown_1 = __importDefault(require("../../Markdown"));
const propTypes = {
    provider: (0, prop_types_1.shape)({
        provider_type: prop_types_1.string
    }).isRequired,
    apptTypeDisclaimers: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
        enabled: prop_types_1.bool,
        provider_type: prop_types_1.string,
        markdown: (0, prop_types_1.arrayOf)(prop_types_1.string)
    }))
};
const defaultProps = {
    apptTypeDisclaimers: []
};
function ApptTypeDisclaimer({ provider, apptTypeDisclaimers }) {
    // Array.find vs Array.match b/c limiting to one disclaimer per provider_type
    const disclaimer = apptTypeDisclaimers.find((apptTypeDisclaimer) => {
        const isMatch = apptTypeDisclaimer.provider_type === provider.provider_type;
        return apptTypeDisclaimer.enabled && isMatch;
    });
    return disclaimer ? react_1.default.createElement(Disclaimer, { markdown: disclaimer.markdown }) : null;
}
exports.default = ApptTypeDisclaimer;
function Disclaimer({ markdown }) {
    return (react_1.default.createElement(styles_1.Container, { "data-testid": "ApptTypeDisclaimer" },
        react_1.default.createElement(Banners_1.InfoBanner, null,
            react_1.default.createElement(Markdown_1.default, { markdown: markdown }))));
}
ApptTypeDisclaimer.propTypes = propTypes;
ApptTypeDisclaimer.defaultProps = defaultProps;
//# sourceMappingURL=ApptTypeDisclaimer.js.map